import { EuroCents } from '@espoon-voltti/ts-libs/lib/euro'

export const eurosMin = EuroCents.fromValue(1_00)
export const eurosMax = EuroCents.fromValue(999999_00)
export const eurosTotalMin = EuroCents.fromValue(50_00)
export const eurosNegativeMin = EuroCents.fromValue(-999999_00)
export const eurosZero = EuroCents.fromValue(0)
